import { OrganizationLogo } from "components/OrganizationLogo";
import { useGameContext } from "context/GameContext";
import { isDesktop } from "react-device-detect";
import CustomizedRatings from "../rating";
import SocialMedia from "../social-media";
import GameOverLauwBlauw from "./GameOverLauwBlauw.jpg";
import { Container, Content, ContentContainer, Header, ImageContainer, LogoContainer, RatingContainer } from "./styles";
import { useContent } from "./utils";

const mobileWidth = window.innerWidth;
const padding = 32;
const offset = 41;
const items = 2;
const logoAndPicWidth = (mobileWidth - padding - (mobileWidth < 300 ? offset : 0)) / items;

const Details = ({ gameOverContent }) => {
	const { room } = useGameContext();
	const contentHeader = useContent({ contentId: gameOverContent?.header, defaultId: "GAME_OVER.content.header" });
	const contentSubHeader = useContent({
		contentId: gameOverContent?.subheader,
		defaultId: "GAME_OVER.content.details",
	});
	return (
		<Container maxWidth={false}>
			<LogoContainer container>
				{isDesktop ? <OrganizationLogo /> : <PicAndLogo thankyouImageUrl={gameOverContent?.thankyouImageUrl} />}
			</LogoContainer>
			<ContentContainer container>
				<Header
					data-testid="game-over-heading"
					variant="h2"
					dangerouslySetInnerHTML={{ __html: contentHeader }}
				/>
				<Content data-testid="game-over-content" dangerouslySetInnerHTML={{ __html: contentSubHeader }} />
			</ContentContainer>
			<RatingContainer container hideSocial={!room?.mediaLinks}>
				{room?.mediaLinks && <SocialMedia socialMediaTitle={gameOverContent?.socialMediaTitle} />}
				<CustomizedRatings gameOverContent={gameOverContent} />
				{isDesktop && (
					<ImageContainer
						style={{
							background: `url(${gameOverContent?.thankyouImageUrl || GameOverLauwBlauw}) no-repeat`,
							backgroundPosition: "center",
							backgroundSize: "cover",
						}}
					></ImageContainer>
				)}
			</RatingContainer>
		</Container>
	);
};

const LOGOCONTAINER = {
	maxWidth: logoAndPicWidth,
	maxHeight: 119,
	display: "flex",
	justifyContent: "center",
	alignItems: "center",
};

const PicAndLogo = ({ thankyouImageUrl }) => {
	return (
		<>
			<img
				src={`${thankyouImageUrl || GameOverLauwBlauw}`}
				style={{ width: logoAndPicWidth, height: 119, objectFit: "cover" }}
				alt="company end game pic"
			/>
			<div style={LOGOCONTAINER}>
				<OrganizationLogo type="img" />
			</div>
		</>
	);
};

export default Details;
